export const SafeV2 = [
  'function VERSION() view returns (string)',
  'function addOwnerWithThreshold(address owner, uint256 _threshold)',
  'function approveHash(bytes32 hashToApprove)',
  'function approvedHashes(address, bytes32) view returns (uint256)',
  'function changeThreshold(uint256 _threshold)',
  'function checkNSignatures(bytes32 dataHash, bytes data, bytes signatures, uint256 requiredSignatures) view',
  'function checkSignatures(bytes32 dataHash, bytes data, bytes signatures) view',
  'function disableModule(address prevModule, address module)',
  'function domainSeparator() view returns (bytes32)',
  'function enableModule(address module)',
  'function encodeTransactionData(address to, uint256 value, bytes data, uint8 operation, uint256 safeTxGas, uint256 baseGas, uint256 gasPrice, address gasToken, address refundReceiver, uint256 _nonce) view returns (bytes)',
  'function execTransaction(address to, uint256 value, bytes data, uint8 operation, uint256 safeTxGas, uint256 baseGas, uint256 gasPrice, address gasToken, address refundReceiver, bytes signatures) payable returns (bool)',
  'function execTransactionFromModule(address to, uint256 value, bytes data, uint8 operation) returns (bool success)',
  'function execTransactionFromModuleReturnData(address to, uint256 value, bytes data, uint8 operation) returns (bool success, bytes returnData)',
  'function getChainId() view returns (uint256)',
  'function getModulesPaginated(address start, uint256 pageSize) view returns (address[] array, address next)',
  'function getOwners() view returns (address[])',
  'function getStorageAt(uint256 offset, uint256 length) view returns (bytes)',
  'function getThreshold() view returns (uint256)',
  'function getTransactionHash(address to, uint256 value, bytes data, uint8 operation, uint256 safeTxGas, uint256 baseGas, uint256 gasPrice, address gasToken, address refundReceiver, uint256 _nonce) view returns (bytes32)',
  'function isModuleEnabled(address module) view returns (bool)',
  'function isOwner(address owner) view returns (bool)',
  'function nonce() view returns (uint256)',
  'function removeOwner(address prevOwner, address owner, uint256 _threshold)',
  'function setFallbackHandler(address handler)',
  'function setGuard(address guard)',
  'function setup(address[] _owners, uint256 _threshold, address to, bytes data, address fallbackHandler, address paymentToken, uint256 payment, address paymentReceiver)',
  'function signedMessages(bytes32) view returns (uint256)',
  'function simulateAndRevert(address targetContract, bytes calldataPayload)',
  'function swapOwner(address prevOwner, address oldOwner, address newOwner)'
]
